import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const swaggerHub = defineConnector({
  identifier: "swaggerHub",
  name: "SwaggerHub",
  tagLine: "API design and documentation",
  logo,
  protocol: "http",
  tags: ["engineering", "documents"],
  defaultUrlPattern: () => "https://api\\.swaggerhub\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a SwaggerHub API key",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key in SwaggerHub and copy it. SwaggerHub’s public docs use the raw key in the `Authorization` header.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.swaggerhub.com/user-management/v1/orgs",
  },
});
